import { render, staticRenderFns } from "./Pixel.vue?vue&type=template&id=5641b548&"
import script from "./Pixel.vue?vue&type=script&lang=ts&"
export * from "./Pixel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports